module.exports = __webpack_public_path__ + "static/api-296be2be61162ec8f79b0658ab6e8939.svg";